<template>
  <section>
    <modal-feature-type :resetInputPayment.sync="callResetPayment" :reloadFunction.sync="uriBoleto"
                        :objToModal="dataModalFeatureType"/>
    <modal-change-financial-email :newChangeFinancialEmail.sync="callChangeNewFinancialEmail" :dataCompanyModal="dataCompanyModal"/>

    <box-default>
      <box-list-filter title="Nova venda">
        <input-text col="4" type="text" placeholder="Digite o ID da empresa" label="ID da empresa:" font-label="16px"
                    :value-default="companyId"
                    @contentText="value => companyId = value"/>
        <div class="btn-initial">
          <btn-custom col="3" label="Pesquisar" @emit-click="getContext()" :disabled="loadingList"/>
        </div>
      </box-list-filter>

      <waiting-list :loading-content="loadingList">
        <div class="box-sales-default">
          <div v-if="dataPaymentCompany.company" class="col-md-12 box-content-sales company-info">
            <h2>Dados da empresa</h2>
            <div class="col-md-12 company-info-content">
              <p class="col-md-3 data-company">
                Nome da empresa:
                <span>{{ dataPaymentCompany.company.name }}</span>
              </p>
              <p class="col-md-3 data-company">
                Nome de contato:
                <span>{{ dataPaymentCompany.company.contactName }}</span>
              </p>
              <p class="col-md-3 data-company">
                E-mail:
                <span>{{ dataPaymentCompany.company.email }}</span>
              </p>
              <div class="bold">
                E-mail financeiro:
                <p class="col-md-3 data-company-email">
                  <span>{{ dataPaymentCompany.company.financialEmail }}</span>
                <button class="change-email-btn" v-on:click="callChangeNewFinancialEmail()">
                  Alterar
                </button>
                </p>
              </div>
            </div>
            <div class="col-md-12 company-info-content">
              <p class="col-md-3 data-company">
                CNPJ:
                <span>{{ dataPaymentCompany.company.bussinessInfo.cnpj }}</span>
              </p>
              <p class="col-md-3 data-company">
                Razão social:
                <span>{{ dataPaymentCompany.company.bussinessInfo.representationName }}</span>
              </p>
              <p class="col-md-3 data-company">
                Telefone:
                <span>{{ dataPaymentCompany.company.phone.phoneNumber }}</span>
              </p>
              <p class="col-md-3 data-company">
                CEP:
                <span>{{ dataPaymentCompany.company.address.zipCode }}</span>
              </p>
            </div>
            <div class="col-md-12 company-info-content">
              <p class="col-md-3 data-company">
                Endereço:
                <span>{{ dataPaymentCompany.company.address.street }}</span>
              </p>
              <p class="col-md-3 data-company">
                Número:
                <span>{{ dataPaymentCompany.company.address.number }}</span>
              </p>
              <p class="col-md-3 data-company">
                Bairro:
                <span>{{ dataPaymentCompany.company.address.neighborhood }}</span>
              </p>
              <p class="col-md-3 data-company">
                Cidade:
                <span>{{ dataPaymentCompany.company.address.city }}</span>
              </p>
            </div>
            <div class="col-md-12 company-info-content">
              <p class="col-md-3 data-company">
                Estado:
                <span>{{ dataPaymentCompany.company.address.state }}</span>
              </p>
              <p class="col-md-3 data-company">
                Complemento:
                <span>{{ dataPaymentCompany.company.address.complement }}</span>
              </p>
              <p class="col-md-3 data-company">
                Latitude:
                <span>{{ dataPaymentCompany.company.address.latitude }}</span>
              </p>
              <p class="col-md-3 data-company">
                Longitude:
                <span>{{ dataPaymentCompany.company.address.longitude }}</span>
              </p>
            </div>
            <h2>Dados para nota fiscal</h2>
            <div class="col-md-12 company-info-content">
              <p class="col-md-3 data-company">
                CNPJ para nota fiscal:
                <span>{{ dataFinancialInfo.financialInfo.cnpj }}</span>
              </p>
              <p class="col-md-3 data-company">
                Razão social para nota fiscal:
                <span>{{ dataFinancialInfo.financialInfo.representationName }}</span>
              </p>
              <p class="col-md-3 data-company">
                CEP para nota fiscal:
                <span>{{ dataFinancialInfo.financialInfo.zipCode }}</span>
              </p>
              <p class="col-md-3 data-company">
                Endereço para nota fiscal:
                <span>{{ dataFinancialInfo.financialInfo.street }}</span>
              </p>
            </div>
            <div class="col-md-12 company-info-content">
              <p class="col-md-3 data-company">
                Número para nota fiscal:
                <span>{{ dataFinancialInfo.financialInfo.number }}</span>
              </p>
              <p class="col-md-3 data-company">
                Complemento para nota fiscal:
                <span>{{ dataFinancialInfo.financialInfo.complement }}</span>
              </p>
              <p class="col-md-3 data-company">
                Bairro para nota fiscal:
                <span>{{ dataFinancialInfo.financialInfo.neighborhood }}</span>
              </p>
              <p class="col-md-3 data-company">
                Cidade para nota fiscal:
                <span>{{ dataFinancialInfo.financialInfo.city }}</span>
              </p>
            </div>
            <div class="col-md-12 company-info-content">
              <p class="col-md-3 data-company">
                Estado para nota fiscal:
                <span>{{ dataFinancialInfo.financialInfo.state }}</span>
              </p>
            </div>
            <h2>Dados do plano</h2>
            <div class="col-md-12 company-info-content">
              <p class="col-md-3 data-company">
                Plano escolhido:
                <span>{{ dataSubscription.companyPlanStr }} - {{ dataSubscription.planTypeStr }}</span>
              </p>
              <p class="col-md-3 data-company">
                Data de criação:
                <span>{{ dataPaymentCompany.company.createdAt | formatDate }}</span>
              </p>
              <p class="col-md-3 data-company">
                Data de vencimento:
                <span>{{ dataSubscription.recurringDayStr }}</span>
              </p>
              <p class="col-md-3 data-company">
                Último pagamento:
                <span>{{ dataSubscription.lastBankSlipPaidDateStr }}</span>
              </p>
            </div>
            <div class="col-md-12 company-info-content">
              <p class="col-md-3 data-company">
                Funcionários:
                <span>{{ dataPaymentCompany.totalEmployee }}</span>
              </p>
              <p class="col-md-3 data-company">
                Data do último acesso admin:
                <span>{{ dataPaymentCompany.lastLoginAdmin | formatDate }}</span>
              </p>
              <p class="col-md-3 data-company">
                Valor:
                <span>R$ {{ dataSubscription.totalCost }}</span>
              </p>
              <p class="col-md-3 data-company">
                Observações:
                <span>{{ dataPaymentCompany.company.notes }}</span>
              </p>
            </div>
          </div>
        </div>

        <div class="box-sales-default">
          <div v-if="dataPaymentCompany.company" class="col-md-12 box-content-sales box-filters">
            <h2>Gerar venda</h2>
            <span class="col-md-12 filters-content">
              <h3>Passagem de bastão p/ Onboarding</h3>
              <input-text :is-required="true" col="6" type="text" placeholder="Digite aqui..." label="Cliente possui alguma particularidade?" font-label="16px" :input-error="errorPrice.particularNotes" :font-error="true" @contentText="value => dataPrice.particularNotes = value"/>
              <input-text :is-required="true" col="6" type="text" placeholder="Digite aqui..." label="Qual o segmento do cliente?" font-label="16px" :input-error="errorPrice.clientSegment" :font-error="true" @contentText="value => dataPrice.clientSegment = value"/>
              <input-text :is-required="true" col="6" type="text" placeholder="Digite aqui..." label="Qual a principal necessidade?" font-label="16px" :input-error="errorPrice.mainNeed" :font-error="true" @contentText="value => dataPrice.mainNeed = value"/>
              <input-text :is-required="true" col="6" type="text" placeholder="Digite aqui..." label="Foi feito algum processo de convencimento?" font-label="16px" :input-error="errorPrice.exclusiveNegotiation" :font-error="true" @contentText="value => dataPrice.exclusiveNegotiation = value"/>
              <input-text :is-required="true" col="6" type="text" placeholder="Digite aqui..." label="Como controla o ponto atualmente? (já possui sistema?)" font-label="16px" :input-error="errorPrice.howManageJourneyBefore" :font-error="true" @contentText="value => dataPrice.howManageJourneyBefore = value"/>
              <input-text :is-required="true" col="6" type="text" placeholder="Digite aqui..." label="Quantidade de colaboradores?" font-label="16px" :input-error="errorPrice.totalEmployeeInInitialContract" :font-error="true" @contentText="value => dataPrice.totalEmployeeInInitialContract = value"/>
            </span>
            <div class="col-md-12 filters-content">
              <h3>Informações de venda</h3>
              <input-select col="3" :options="saleType" label="Tipo de venda:" font-label="16px" :font-error="true" :is-required="true" :input-error="errorPrice.saleType" @selectedOption="value => dataPrice.saleType = value"/>
              <input-select col="3" :options="moduleTypes" label="Módulo:" :value-selected="true" :content-value-selected="dataPrice.moduleType" font-label="16px" :font-error="true" :is-required="true" :input-error="errorPrice.moduleType" @contentValueSelected="value => dataPrice.moduleType = value"/>
              <input-select col="3" :options="trueOrFalse" label="Venda parcelada:" font-label="16px" :font-error="true" @selectedOption="value => dataPrice.hasInstallments = value"/>
              <div v-if="dataPrice.hasInstallments === 'true'">
                <input-text col="3" type="text" placeholder="Ex: 05" label="Quantidade de parcelas:" font-label="16px" :is-required="dataPrice.hasInstallments" :input-error="errorPrice.installmentsQuantity" @contentText="value => dataPrice.installmentsQuantity = value"/>
              </div>
              <input-text col="3" type="text" placeholder="Digite aqui..." label="Promoção:" font-label="16px" @contentText="value => dataPrice.promotion = value"/>
              <input-text col="3" type="text" placeholder="Digite aqui..." label="Desconto:" font-label="16px" @contentText="value => dataPrice.discount = value"/>
              <input-text col="3" type="text" placeholder="Digite aqui..." label="Cortesia:" font-label="16px" @contentText="value => dataPrice.courtesy = value"/>
              <input-text col="3" type="text" placeholder="Digite aqui..." label="Informação adicional:" font-label="16px" @contentText="value => dataPrice.notes = value"/>
            </div>
            <div class="col-md-12 filters-content">
              <h3>Informações de marketing</h3>
              <input-text col="3" type="text" placeholder="Digite aqui..." label="Origem do lead:" font-label="16px" @contentText="value => dataPrice.leadOrigin = value"/>
              <input-text col="3" type="text" placeholder="Digite aqui..." label="UTM Fonte:" font-label="16px" @contentText="value => dataPrice.utmSource = value"/>
              <input-text col="3" type="text" placeholder="Digite aqui..." label="UTM Médio:" font-label="16px" @contentText="value => dataPrice.utmMedium = value"/>
              <input-text col="3" type="text" placeholder="Digite aqui..." label="UTM Campanha:" font-label="16px" @contentText="value => dataPrice.utmCampaign = value"/>
              <input-text col="3" type="text" placeholder="Digite aqui..." label="UTM personalizado 1:" font-label="16px" @contentText="value => dataPrice.utmCustom1 = value"/>
              <input-text col="3" type="text" placeholder="Digite aqui..." label="UTM personalizado 2:" font-label="16px" @contentText="value => dataPrice.utmCustom2 = value"/>
            </div>
            <div class="col-md-12 filters-content">
              <h3>Dados da assinatura</h3>
              <input-select col="3" :options="listPlansType" label="Plano:" font-label="16px" :font-error="true" :is-required="true" :input-error="errorPrice.planId"
                            @selectedOption="value => dataPrice.planId = value"/>
              <input-select col="3" :options="months" label="Essa venda vai para qual mês:" font-label="16px" :font-error="true" :is-required="true" :input-error="errorPrice.month" :value-selected="true" :content-value-selected="dataPrice.month"
                            @contentValueSelected="value => dataPrice.month = value"/>
              <input-select col="3" :options="planType" label="Tipo do plano:" font-label="16px" :font-error="true" :is-required="true" :input-error="errorPrice.planType" @selectedOption="value => dataPrice.planType = value"/>
              <input-select col="3" :options="paymentMethods" label="Método de pagamento:" font-label="16px" :font-error="true" :is-required="true" :input-error="errorPrice.paymentMethod" @selectedOption="value => dataPrice.paymentMethod = value"/>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="priceToCharge">Preço de cobrança: <span>*</span></span></label>
                  <input v-model.lazy="priceToCharge" v-money="money1" type="text"
                         class="form-control" id="priceToCharge" name="priceToCharge" required/>
                  <span v-if="errorPrice.priceToCharge" class="error-msg">{{ errorPrice.priceToCharge }}</span>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="recurringPrice">Preço recorrente: <span>*</span></label>
                  <input v-model.lazy="dataPrice.recurringPrice" v-money="money1" type="text"
                         class="form-control" id="recurringPrice" name="recurringPrice" required/>
                  <span v-if="errorPrice.recurringPrice" class="error-msg">{{ errorPrice.recurringPrice }}</span>
                </div>
              </div>
              <div class="col-md-3">
                <div class="input-group input-with-date-filter">
                  <label>Vencimento do boleto: <span>*</span></label>
                  <datepicker ref="inputDateSale1" v-model="dataPrice.expireAt" :language="ptBR" placeholder="dd/mm/yyyy"
                              :format="customFormatterDate"/>
                  <i v-on:click="openCalendarSale1()" class="fa fa-calendar" aria-hidden="true"></i>
                  <span v-if="errorPrice.expireAt" class="error-msg">{{ errorPrice.expireAt }}</span>
                </div>
              </div>
              <input-text col="3" type="text" :is-required="true" :validate-days-of-the-month="true" :input-error="errorPrice.recurringDay" placeholder="Ex: 05" label="Dia recorrente:" :font-error="true" font-label="16px"
                          @contentText="value => dataPrice.recurringDay = value"/>
              <div class="col-md-3">
                <div class="input-group input-with-date-filter">
                  <label>Começa em: <span>*</span></label>
                  <datepicker ref="inputDateSale" v-model="dataPrice.startAt" :language="ptBR" placeholder="dd/mm/yyyy"
                              :format="customFormatterDate"/>
                  <i v-on:click="openCalendarSale()" class="fa fa-calendar" aria-hidden="true"></i>
                  <span v-if="errorPrice.startAt" class="error-msg">{{ errorPrice.startAt }}</span>
                </div>
              </div>
              <input-text col="3" type="text" placeholder="Ex: 10" :is-required="true" :input-error="errorPrice.totalEmployeeHr" label="Total de funcionários:" :font-error="true" font-label="16px"
                          @contentText="value => totalEmployees = value"/>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="pricePerEmployeeHr">Valor por funcionário: <span>*</span></span></label>
                  <input v-model.lazy="dataPrice.pricePerEmployeeHr" v-money="money1" type="text"
                         class="form-control" id="pricePerEmployeeHr" name="pricePerEmployeeHr" required/>
                  <span v-if="errorPrice.pricePerEmployeeHr" class="error-msg">{{ errorPrice.pricePerEmployeeHr }}</span>
                </div>
              </div>
              <input-select col="3" :options="unit" label="Unidade de negócio:" font-label="16px" :font-error="true"
                            @selectedOption="value => dataPrice.businessUnitId = value"/>
              <div v-if="dataPrice.moduleType > 0">
                <input-text col="3" type="text" placeholder="Ex: 05" label="Funcionários com Beneflex:" font-label="16px" :font-error="true" :is-required="true" :input-error="errorPrice.totalEmployeeBeneflex" @contentText="value => dataPrice.totalEmployeeBeneflex = value"/>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="pricePerEmployeeBeneflex">Valor por funcionário (Beneflex): <span>*</span></span></label>
                    <input v-model.lazy="dataPrice.pricePerEmployeeBeneflex" v-money="money1" type="text"
                           class="form-control" id="pricePerEmployeeBeneflex" name="pricePerEmployeeBeneflex" required/>
                    <span v-if="errorPrice.pricePerEmployeeBeneflex" class="error-msg">{{ errorPrice.pricePerEmployeeBeneflex }}</span>
                  </div>
                </div>
              </div>
              <input-select col="3" :options="trueOrFalse" label="Gerar nota:" :value-selected="true" font-label="16px" :font-error="true" :content-value-selected="dataPrice.generateInvoice"
                            @contentValueSelected="value => dataPrice.generateInvoice = value"/>
              <div class="col-md-3" v-if="dataPrice.generateInvoice">
                <div class="input-group input-with-date-filter">
                  <label>Data de emissão: </label>
                  <datepicker ref="inputDateSale2" v-model="dataPrice.invoiceDate" :language="ptBR" placeholder="dd/mm/yyyy"
                              :format="customFormatterDate"/>
                  <i v-on:click="openCalendarSale2()" class="fa fa-calendar" aria-hidden="true"></i>
                  <span v-if="errorPrice.invoiceDate" class="error-msg">{{ errorPrice.invoiceDate }}</span>
                </div>
              </div>
              <div class="col-md-12 b-row filters-content">
                <input-text :is-required="true" col="3" type="text" placeholder="Digite o nome do responsável" label="Nome do responsável:" font-label="16px"
                            @contentText="value => dataPrice.contactName = value"/>
                <input-text :is-required="true" col="3" type="text" :mask="['(##) ####-####', '(##) #####-####', '(##) ######-####', '(##) ## #########', '(###) ## #########']" placeholder="Digite o telefone do responsável" label="Telefone do responsável:" font-label="16px"
                            @contentText="value => dataPrice.contactPhone = value"/>
              </div>
              <input-select col="3" :options="FilterCompanyProfile" label="Perfil:" :value-selected="true" font-label="16px" :font-error="true" :content-value-selected="dataPrice.companyTier"
                            @contentValueSelected="value => changeProfileValidate(value)"/>
              <input-select col="3" :options="selectBohOrAsaas" label="Plataforma de pagamento" font-label="16px" :font-error="true" :is-required="true" :input-error="errorPrice.billingTarget"
                            @selectedOption="value => dataPrice.billingTarget = value"/>
              <div v-if="dataPrice.billingTarget === 1" class="col-md-3 check-boh">
                <input-checkbox col="12" label="É BOH?" @valueCheckbox="value => dataPrice.fromBOH = value"/>
              </div>
              <div v-if="dataPrice.generateInvoice || invoiceNoteIsRequired" class="col-md-12 filters-content input-space">
                <input-text col="6" type="text" placeholder="Digite a observação" label="Observação da nota:" :is-required="invoiceNoteIsRequired" :font-error="true" font-label="16px"
                            @contentText="value => dataPrice.invoiceNotes = value" :input-error="errorPrice.invoiceNote"/>
              </div>
              <btn-custom label="Enviar" @emit-click="sendValue" :have-loading="true" :loading="loadingPayment"/>
            </div>
          </div>
        </div>
      </waiting-list>
    </box-default>
  </section>
</template>

<script>
import {
  CONTEXT_COMPANY,
  CHANGE_DADE_FINANCIAL,
  COMPANY_PAYMENT_INFO, FEATURES_ALL,
  GET_SALES_INFORMATION,
  GET_SUB_PLANS2, GET_UNIT_MASTER
} from "../../../../urlConfig";
import modalChangeFinancialEmail from "../../modals/modalChangeFinancialEmail.vue";
import TopMenu from "../../components/default/topMenu.vue";
import BoxDefault from "../../components/layouts/boxDefault.vue";
import BoxListFilter from "../../components/layouts/boxListFilter.vue";
import InputText from "../../components/inputs/inputText.vue";
import BtnCustom from "../../components/buttons/btnCustom.vue";
import WaitingList from "../../components/layouts/waitingList.vue";
import {REQUEST_SERVICE} from "../../../../requestConfig";
import {UTIL_SERVICE} from "../../../../utils";
import swal from "sweetalert";
import InputSelect from "../../components/inputs/inputSelect.vue";
import moment from "moment";
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import datepicker from "vuejs-datepicker";
import ModalFeatureType from "../../modals/modalFeatureType.vue";
import {
  VMoney
} from "v-money";
import fullLoading from "../../components/default/fullLoading.vue";
import InputCheckbox from "../../components/inputs/inputCheckbox.vue";

export default {
  name: "new-sale",
  components: {
    InputCheckbox,
    modalChangeFinancialEmail,
    fullLoading,
    ModalFeatureType,
    InputSelect,
    WaitingList,
    BtnCustom,
    BoxListFilter,
    BoxDefault,
    TopMenu,
    InputText,
    datepicker
  },
  directives: {
    money: VMoney,
  },
  data() {
    return {
      loadingList: false,
      companyId: '',
      context: '',
      unit: [],
      ptBR: ptBR,
      priceToCharge: '',
      totalEmployees: '',
      dataCompanyModal: {
        modalContext: '',
        companyValue: {}
      },
      dataPaymentCompany: {},
      dataSubscription: {},
      dataFinancialInfo: {},
      listPlansType: [],
      companyProfile: "",
      invoiceNoteIsRequired: false,
      dataPrice: {
        businessUnitId: "",
        planId: "",
        paymentMethod: "",
        month: "",
        generateInvoice: "",
        companyId: this.companyId,
        planType: "",
        priceToCharge: "",
        recurringPrice: "",
        expireAt: "",
        recurringDay: "",
        startAt: "",
        totalEmployeeHr: "",
        pricePerEmployeeHr: "",
        totalEmployeeBeneflex: "",
        pricePerEmployeeBeneflex: "",
        invoiceDate: "",
        invoiceNotes: "",
        saleType: "",
        moduleType: "",
        hasInstallments: "",
        installmentsQuantity: "",
        promotion: "",
        discount: "",
        courtesy: "",
        notes: "",
        leadOrigin: "",
        utmSource: "",
        utmMedium: "",
        utmCampaign: "",
        utmCustom1: "",
        utmCustom2: "",
        companyTier: "",
        contactName: "",
        contactPhone: "",
        particularNotes: "",
        clientSegment: "",
        mainNeed: "",
        exclusiveNegotiation: "",
        howManageJourneyBefore: "",
        totalEmployeeInInitialContract: "",
        billingTarget: "",
        fromBOH: false,
      },
      money1: {
        decimal: ".",
        thousands: ",",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false,
      },
      errorPrice: {
        planType: "",
        priceToCharge: "",
        recurringPrice: "",
        expireAt: "",
        recurringDay: "",
        startAt: "",
        totalEmployeeHr: "",
        month: "",
        planId: "",
        invoiceDate: "",
        pricePerEmployeeHr: "",
        pricePerEmployeeBeneflex: "",
        totalEmployeeBeneflex: "",
        installmentsQuantity: "",
        paymentMethod: "",
        businessUnitId: "",
        saleType: "",
        moduleType: "",
        notes: "",
        invoiceNote: "",
        particularNotes: "",
        clientSegment: "",
        mainNeed: "",
        exclusiveNegotiation: "",
        howManageJourneyBefore: "",
        totalEmployeeInInitialContract: "",
        billingTarget: "",
      },
      trueOrFalse: [
        {
          id: '',
          name: "Não"
        },
        {
          id: 'true',
          name: "Sim"
        }
      ],
      selectBohOrAsaas: [
        {
          id: '',
          name: 'Selecione'
        },
        {
          id: 0,
          name: 'IUGU'
        },
        {
          id: 1,
          name: 'ASAAS'
        },
      ],
      FilterCompanyProfile: [
        {id: 'A', name: 'A'},
        {id: 'B', name: 'B'},
        {id: 'C', name: 'C'},
        {id: 'D', name: 'D'},
        {id: 'E', name: 'E'},
      ],
      months: [
        {id: '', name: 'Selecione'},
        {id: 1, name: 'Janeiro'},
        {id: 2, name: 'Fevereiro'},
        {id: 3, name: 'Março'},
        {id: 4, name: 'Abril'},
        {id: 5, name: 'Maio'},
        {id: 6, name: 'Junho'},
        {id: 7, name: 'Julho'},
        {id: 8, name: 'Agosto'},
        {id: 9, name: 'Setembro'},
        {id: 10, name: 'Outubro'},
        {id: 11, name: 'Novembro'},
        {id: 12, name: 'Dezembro'}
      ],
      planType: [
        {
          id: '',
          name: 'Selecione'
        },
        {
          id: 1,
          name: 'Mensal'
        },
        {
          id: 2,
          name: 'Bimestral'
        },
        {
          id: 3,
          name: 'Trimestral'
        },
        {
          id: 4,
          name: 'Semestral'
        },
        {
          id: 5,
          name: 'Anual'
        },
        {
          id: 6,
          name: 'Bianual'
        }
      ],
      saleType: [
        {
          id: '',
          name: 'Selecione'
        },
        {
          id: 0,
          name: 'Vendas'
        },
        {
          id: 1,
          name: 'Upsell'
        }
      ],
      moduleTypes: [
        {
          id: '',
          name: 'Selecione'
        },
        {
          id: 0,
          name: 'MarQPonto'
        },
        {
          id: 1,
          name: 'Beneflex'
        },
        {
          id: 2,
          name: 'Ambos'
        }
      ],
      paymentMethods: [
        {
          id: '',
          name: 'Selecione'
        },
        {
          id: 1,
          name: 'Boleto'
        },
        {
          id: 2,
          name: 'Cartão de crédito'
        },
        {
          id: 4,
          name: 'Transferência bancária'
        },
        {
          id: 7,
          name: 'Pix'
        }
      ],
      callResetPayment: '',
      dataModalFeatureType: '',
      uriBoleto: '',
      loadingPayment: false,
    }
  },

  methods: {
    callChangeNewFinancialEmail () {
      this.dataCompanyModal.modalContext = this.context;
      this.dataCompanyModal.companyValue = this.dataPaymentCompany.company;

      $("#modalChangeFinancialEmail").modal();
    },
    getContext() {
      REQUEST_SERVICE.get(CONTEXT_COMPANY + this.companyId).then((response) => {
        this.context = response.data
        this.getPaymentInfo();
      }).catch(() => {
        swal("Erro", "Verifique a informação e tente novamente!")
      })
    },
    changeProfileValidate(value) {
      this.dataPrice.companyTier = value;
      this.companyProfile !== this.dataPrice.companyTier ? this.invoiceNoteIsRequired = true : this.invoiceNoteIsRequired = false;
    },
    changeProfile(value) {
      if (value >= 100) return 'A';
      if (value >= 50 && value <= 99) return 'B';
      if (value >= 21 && value <= 49) return 'C';
      if (value >= 11 && value <= 20) return 'D';
      if (value <= 10) return 'E';
    },
    getPaymentInfo() {
      this.dataModalFeatureType = '';
      this.uriBoleto = '';
      this.loadingList = true;
      let url = COMPANY_PAYMENT_INFO;
      url += "?t=kkkk&i=" + this.companyId;

      REQUEST_SERVICE.requestContext("GET", url, this.context).then(response => {
        UTIL_SERVICE.console("RESULT COMPANY_PAYMENT_INFO: ", response.data);
        this.dataPaymentCompany = response.data;
        this.dataPrice.moduleType = response.data.moduleType;
        this.dataSubscription = response.data.subscription;
        this.getDadeFinancial();
        this.loadingList = false;
      }).catch((reason) => {
        this.loadingList = false;
        swal("Aviso", "ID não encontrado, tente novamente!", "error");
      });
    },
    getDadeFinancial() {
      let url = CHANGE_DADE_FINANCIAL + "?i=" + this.companyId;
      REQUEST_SERVICE.requestContext("GET", url, this.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT CHANGE_DADE_FINANCIAL:", response.data);
          this.dataFinancialInfo = response.data;
          this.loadSubsPlan();
          this.getSelectUnitMaster();
        }).catch((reason) => {
        this.loadinDadeList = false;
        this.loading = false;
      });
    },
    loadSubsPlan() {
      if (!this.listPlansType.length) {
        REQUEST_SERVICE.requestContext("GET", GET_SUB_PLANS2, this.context)
          .then((response) => {
            UTIL_SERVICE.console("RESULT GET_SUB_PLANS2:", response.data);

            this.listPlansType = [{id: '', name: 'Selecione'}];
            response.data.map((v, index) => {
              this.listPlansType.push(v);
            });
          }).catch((reason) => {
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
      }
    },
    getSelectUnitMaster() {
      let url = GET_UNIT_MASTER;
      url += "?i=" + this.companyId;
      REQUEST_SERVICE.requestContext("GET", url, this.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT GET_UNIT_MASTER:", response.data);

          this.unit = [{id: '', name: 'Selecione'}, ...response.data];
        })
        .catch((reason) => {
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    sendValue() {
      this.errorPrice.planType = "";
      this.errorPrice.priceToCharge = "";
      this.errorPrice.recurringPrice = "";
      this.errorPrice.expireAt = "";
      this.errorPrice.recurringDay = "";
      this.errorPrice.startAt = "";
      this.errorPrice.totalEmployeeHr = "";
      this.errorPrice.pricePerEmployeeHr = "";
      this.errorPrice.totalEmployeeBeneflex = "";
      this.errorPrice.pricePerEmployeeBeneflex = "";
      this.errorPrice.invoiceDate = "";
      this.errorPrice.planId = "";
      this.errorPrice.month = "";
      this.errorPrice.installmentsQuantity = "";
      this.errorPrice.paymentMethod = "";
      this.errorPrice.saleType = "";
      this.errorPrice.moduleType = "";
      this.errorPrice.invoiceNote = "";
      this.errorPrice.particularNotes = "";
      this.errorPrice.clientSegment = "";
      this.errorPrice.mainNeed = "";
      this.errorPrice.exclusiveNegotiation = "";
      this.errorPrice.howManageJourneyBefore = "";
      this.errorPrice.totalEmployeeInInitialContract = "";
      this.errorPrice.billingTarget = "";

      if (
        this.dataPrice.generateInvoice === "true" &&
        !this.dataPrice.invoiceDate
      ) {
        this.errorPrice.invoiceDate = "Valor obrigatório.";
        return;
      }

      if(this.dataPrice.hasInstallments && this.dataPrice.installmentsQuantity === "") {
        this.errorPrice.installmentsQuantity = "Valor obrigatório.";
        return;
      }

      if (this.invoiceNoteIsRequired && this.dataPrice.invoiceNotes === "") {
        this.errorPrice.invoiceNote = "Valor obrigatório.";
        return;
      }

      if (
        this.dataPrice.particularNotes &&
        this.dataPrice.clientSegment &&
        this.dataPrice.mainNeed &&
        this.dataPrice.exclusiveNegotiation &&
        this.dataPrice.howManageJourneyBefore &&
        this.dataPrice.totalEmployeeInInitialContract &&
        this.dataPrice.planId &&
        this.dataPrice.month &&
        this.dataPrice.planType &&
        this.dataPrice.startAt &&
        this.dataPrice.expireAt &&
        this.dataPrice.recurringDay &&
        this.dataPrice.totalEmployeeHr &&
        this.dataPrice.paymentMethod &&
        this.dataPrice.billingTarget !== "" &&
        this.dataPrice.priceToCharge !== "R$ 0.00" &&
        this.dataPrice.recurringPrice !== "R$ 0.00" &&
        this.dataPrice.pricePerEmployeeHr !== "R$ 0.00" &&
        this.dataPrice.saleType !== '' &&
        this.dataPrice.moduleType !== ''
      ) {
        if (this.dataPrice.moduleType > 0 && (this.dataPrice.pricePerEmployeeBeneflex === "R$ 0.00" || this.dataPrice.totalEmployeeBeneflex === "")) {
          if (this.dataPrice.pricePerEmployeeBeneflex === "R$ 0.00") this.errorPrice.pricePerEmployeeBeneflex = "Valor obrigatório.";
          if (this.dataPrice.totalEmployeeBeneflex === "") this.errorPrice.totalEmployeeBeneflex = "Valor obrigatório.";
          return;
        }

        if (!this.loadingPayment) {
          this.loadingPayment = true;

          let objToSend = {
            companyId: this.companyId,
            sellerId: this.$route.params.userInfo.id,
            planType: this.dataPrice.planType,
            recurringDay: Number(this.dataPrice.recurringDay),
            totalEmployeeHr: Number(this.dataPrice.totalEmployeeHr),
            businessUnitId: null,
            billingTarget: this.dataPrice.billingTarget,
            fromBOH: this.dataPrice.fromBOH,
          };

          // Ação paliativa para corrigir o gerar venda em 20240416
          objToSend.companyTier = this.GetCompanyTierByTotalEmployeeHr(objToSend.totalEmployeeHr);

          if (this.dataPrice.invoiceDate)
            objToSend.invoiceDate = moment(this.dataPrice.invoiceDate).format(
              "YYYY-MM-DD"
            );

          if (this.dataPrice.businessUnitId)
            objToSend.businessUnitId = this.dataPrice.businessUnitId;

          if (this.dataPrice.invoiceNotes)
            objToSend.invoiceNotes = this.dataPrice.invoiceNotes;

          if (this.dataPrice.planId) objToSend.planId = this.dataPrice.planId;

          if (this.dataPrice.month) objToSend.month = this.dataPrice.month;

          objToSend.startAt = moment(this.dataPrice.startAt).format(
            "YYYY-MM-DD"
          );
          objToSend.expireAt = moment(this.dataPrice.expireAt).format(
            "YYYY-MM-DD"
          );
          objToSend.priceToCharge = this.dataPrice.priceToCharge.replace(
            "R$ ",
            ""
          );
          objToSend.recurringPrice = this.dataPrice.recurringPrice.replace(
            "R$ ",
            ""
          );
          objToSend.pricePerEmployeeHr = this.dataPrice.pricePerEmployeeHr.replace(
            "R$ ",
            ""
          );
          let valuePerEmployee = Number(objToSend.pricePerEmployeeHr);
          let recurringPrice = Number(objToSend.recurringPrice);
          let priceToCharge = Number(objToSend.priceToCharge);

          if (this.dataPrice.generateInvoice === "true") objToSend.generateInvoice = true;

          if (this.dataPrice.paymentMethod) objToSend.paymentMethod = this.dataPrice.paymentMethod;
          if (this.dataPrice.totalEmployeeBeneflex && this.dataPrice.moduleType > 0) objToSend.totalEmployeeBeneflex = Number(this.dataPrice.totalEmployeeBeneflex);
          if (this.dataPrice.pricePerEmployeeBeneflex && this.dataPrice.moduleType > 0) {
            objToSend.pricePerEmployeeBeneflex = this.dataPrice.pricePerEmployeeBeneflex.replace("R$ ", "");
          }
          if (this.dataPrice.saleType) objToSend.saleType = this.dataPrice.saleType;
          if (this.dataPrice.moduleType !== '') objToSend.moduleType = this.dataPrice.moduleType;
          this.dataPrice.hasInstallments ? objToSend.hasInstallments = true : objToSend.hasInstallments = false;
          if (this.dataPrice.installmentsQuantity) objToSend.installmentsQuantity = Number(this.dataPrice.installmentsQuantity);
          if (this.dataPrice.promotion) objToSend.promotion = this.dataPrice.promotion;
          if (this.dataPrice.discount) objToSend.discount = this.dataPrice.discount;
          if (this.dataPrice.courtesy) objToSend.courtesy = this.dataPrice.courtesy;
          if (this.dataPrice.notes) objToSend.notes = this.dataPrice.notes;
          if (this.dataPrice.leadOrigin) objToSend.leadOrigin = this.dataPrice.leadOrigin;
          if (this.dataPrice.utmSource) objToSend.utmSource = this.dataPrice.utmSource;
          if (this.dataPrice.utmMedium) objToSend.utmMedium = this.dataPrice.utmMedium;
          if (this.dataPrice.utmCampaign) objToSend.utmCampaign = this.dataPrice.utmCampaign;
          if (this.dataPrice.utmCustom1) objToSend.utmCustom1 = this.dataPrice.utmCustom1;
          if (this.dataPrice.utmCustom2) objToSend.utmCustom2 = this.dataPrice.utmCustom2;
          if (this.dataPrice.companyTier) objToSend.companyTier = this.dataPrice.companyTier;
          if (this.dataPrice.contactName) objToSend.contactName = this.dataPrice.contactName;
          if (this.dataPrice.contactFinancialEmail) objToSend.contactFinancialEmail = this.dataPrice.contactFinancialEmail;
          if (this.dataPrice.contactPhone) objToSend.contactPhone = this.dataPrice.contactPhone;
          if (this.dataPrice.particularNotes) objToSend.particularNotes = this.dataPrice.particularNotes;
          if (this.dataPrice.clientSegment) objToSend.clientSegment = this.dataPrice.clientSegment;
          if (this.dataPrice.mainNeed) objToSend.mainNeed = this.dataPrice.mainNeed;
          if (this.dataPrice.exclusiveNegotiation) objToSend.exclusiveNegotiation = this.dataPrice.exclusiveNegotiation;
          if (this.dataPrice.howManageJourneyBefore) objToSend.howManageJourneyBefore = this.dataPrice.howManageJourneyBefore;
          if (this.dataPrice.totalEmployeeInInitialContract) objToSend.totalEmployeeInInitialContract = this.dataPrice.totalEmployeeInInitialContract;

          this.dataModalFeatureType = objToSend;
          this.dataModalFeatureType.context = this.context;
          this.dataModalFeatureType.companyName = (this.dataPaymentCompany.company && this.dataPaymentCompany.company.name) || '';
          this.dataModalFeatureType.math = Math.floor(Math.random() * 500);

          this.loadingPayment = false;

          if (valuePerEmployee < 1.00 || recurringPrice < 50.00 || priceToCharge < 50.00) {
            swal({
              title: "Aviso",
              text: `Valor por funcionário R$ ${objToSend.pricePerEmployeeHr} está correto? \n\n Valor recorrente de R$ ${objToSend.recurringPrice} está correto?\n\n Valor de cobrança R$ ${objToSend.priceToCharge} está correto?`,
              icon: "warning",
              buttons: true,
              dangerMode: true
            }).then((value) => {
              if(value) $("#modalFeatureType").modal();
            })
          } else {
            $("#modalFeatureType").modal();
          }
        }
      } else {
        if (!this.dataPrice.planType)
          this.errorPrice.planType = "Valor obrigatório.";

        if (!this.dataPrice.planId)
          this.errorPrice.planId = "Valor obrigatório.";

        if (!this.dataPrice.month) this.errorPrice.month = "Valor obrigatório.";

        if (this.dataPrice.priceToCharge === "R$ 0.00")
          this.errorPrice.priceToCharge = "Valor obrigatório.";

        if (this.dataPrice.recurringPrice === "R$ 0.00")
          this.errorPrice.recurringPrice = "Valor obrigatório.";

        if (!this.dataPrice.expireAt)
          this.errorPrice.expireAt = "Valor obrigatório.";

        if (!this.dataPrice.recurringDay)
          this.errorPrice.recurringDay = "Valor obrigatório.";

        if (!this.dataPrice.startAt)
          this.errorPrice.startAt = "Valor obrigatório.";

        if (!this.dataPrice.totalEmployeeHr)
          this.errorPrice.totalEmployeeHr = "Valor obrigatório.";

        if (this.dataPrice.pricePerEmployeeHr === "R$ 0.00")
          this.errorPrice.pricePerEmployeeHr = "Valor obrigatório.";

        if (!this.dataPrice.paymentMethod)
          this.errorPrice.paymentMethod = "Selecione algum item.";

        if (this.dataPrice.saleType === '')
          this.errorPrice.saleType = "Valor obrigatório.";

        if (this.dataPrice.moduleType === '')
          this.errorPrice.moduleType = "Valor obrigatório";

        if (this.dataPrice.particularNotes === '')
          this.errorPrice.particularNotes = "Valor obrigatório";

        if (this.dataPrice.clientSegment === '')
          this.errorPrice.clientSegment = "Valor obrigatório";

        if (this.dataPrice.mainNeed === '')
          this.errorPrice.mainNeed = "Valor obrigatório";

        if (this.dataPrice.exclusiveNegotiation === '')
          this.errorPrice.exclusiveNegotiation = "Valor obrigatório";

        if (this.dataPrice.howManageJourneyBefore === '')
          this.errorPrice.howManageJourneyBefore = "Valor obrigatório";

        if (this.dataPrice.totalEmployeeInInitialContract === '')
          this.errorPrice.totalEmployeeInInitialContract = "Valor obrigatório";

        if (this.dataPrice.billingTarget === '')
          this.errorPrice.billingTarget = "Valor obrigatório";
      }
    },
    customFormatterDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    openCalendarSale: function () {
      this.$refs.inputDateSale.showCalendar();
    },
    openCalendarSale1: function () {
      this.$refs.inputDateSale1.showCalendar();
    },
    openCalendarSale2: function () {
      this.$refs.inputDateSale2.showCalendar();
    },
    calcRecurringPrice(value, type) {
      let priceClean = value.replace("R$", "");
      if (priceClean.includes(",")) priceClean = priceClean.replace(",", "");
      let priceNumber = Number(priceClean) * 1000;
      let result = 0;

      switch (type) {
        case 2:
          result = priceNumber / 2;
          break;
        case 3:
          result = priceNumber / 3;
          break;
        case 4:
          result = priceNumber / 6;
          break;
        case 5:
          result = priceNumber / 12;
          break;
        case 6:
          result = priceNumber / 24;
          break;
      }

      result = result / 1000;
      return result.toFixed(2);
    },
    GetCompanyTierByTotalEmployeeHr(totalEmployeeHr){
      if (totalEmployeeHr <= 10) {
        return "E";
      }
      else if (totalEmployeeHr >= 11 && totalEmployeeHr <= 20) {
        return "D";
      }
      else if (totalEmployeeHr >= 21 && totalEmployeeHr <= 49) {
        return "C";
      }
      else if (totalEmployeeHr >= 50 && totalEmployeeHr <= 99) {
        return "B";
      }
      else if (totalEmployeeHr >= 100) {
        return "A";
      }
      else{
        return "A";
      }
    }
  },
  watch: {
    totalEmployees: function (value) {
      this.dataPrice.totalEmployeeHr = value;
      this.dataPrice.companyTier = this.changeProfile(value);
      this.companyProfile = this.changeProfile(value);
    },
    callResetPayment: function (v) {
    },
    priceToCharge() {
      this.dataPrice.priceToCharge = this.priceToCharge;
      if (this.dataPrice.planType === 1) {
        this.dataPrice.recurringPrice = this.priceToCharge;
      } else {
        this.dataPrice.recurringPrice = this.calcRecurringPrice(this.dataPrice.priceToCharge, this.dataPrice.planType);
      }
    }
  },
  beforeMount() {
    const actualDate = new Date();
    this.dataPrice.month = actualDate.getMonth() + 1;
    this.dataPrice.expireAt = moment(actualDate).add(1, 'days')._d;
    this.dataPrice.invoiceDate = moment(actualDate).add(1, 'days')._d;
    this.dataPrice.generateInvoice = "true";

    if (this.$route.params.companyId) {
      this.companyId = this.$route.params.companyId;
      this.context = this.$route.params.context;
      this.getPaymentInfo();
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-initial {
  padding-top: 25px;
}

.input-space {
  .input {
    margin-bottom: 40px;
  }
}

.check-boh {
  padding-top: 34px;
  margin-left: -16px;
}

.box-sales-default {
  padding: 0 15px;

  h2 {
    font-size: 21px;
    font-weight: 700;
    line-height: 1.5;
    margin: 0 0 20px 0;

    &:after {
      content: "";
      display: flex;
      width: 100%;
      height: 1px;
      background: #e9e9e9;
      margin-top: 6px;
    }
  }

  .box-content-sales {
    margin-top: 30px;
    padding: 20px;
    background: #fff;
    border-radius: 10px !important;
  }
}

.company-info {
  margin-top: 30px;
  padding: 20px;
  background: #fff;
  border-radius: 10px !important;

  &-content {
    padding: 0;
    margin-bottom: 20px;

    .data-company {
      font-weight: 600;
      box-sizing: border-box;
      margin: 0;

      span {
        display: flex;
        font-weight: 400;
        margin-top: 6px;
      }
    }
    .data-company-email {
      display: flex;
      align-items: center;
      font-weight: 600;
      box-sizing: border-box;
      margin: 0;

      span {
        font-weight: 400;
        margin-top: 6px;
        margin-left: -15px;
      }
    }
    .change-email-btn{
      border: #ffffff;
      border-radius: 4px !important;
      margin-top: 1% !important;
      margin-left: 5% !important;
      border-radius: 4px !important;
      color: #3598DC;
      text-align: center;
      border: 1px solid #3598DC;
      margin-left: 10px;
      padding: 0 30px;
      line-height: 21px;
      cursor: pointer;
      background: #FFF;
      &:hover {
            color: #FFFF;
            background: #3598DC;
          }
    }
  }
}

.box-filters {
  margin-bottom: 80px;
  .filters-content {
    padding: 0;
    margin-bottom: 20px;

    h3 {
      margin: 0 0 16px 0;
      font-size: 18px;
      font-weight: 400;
    }

    .input-with-date-filter {
      label {
        font-size: 16px;

        span {
          position: initial;
          font-size: 14px;
          color: #ff445d;
        }
      }

      span {
        position: absolute;
        font-size: 14px;
        color: #d9534f;
      }
    }

    .form-group {

      label {
        color: #191919;
        font-size: 16px;

        span {
          font-size: 14px;
          color: #ff445d;
        }
      }

      span {
        position: absolute;
        font-size: 14px;
        color: #d9534f;
      }

      .field-txt-invalid {
        position: absolute;
        margin-top: 3px;
      }

      input {
        background: #EEF2F7;
        -webkit-border-radius: 4px !important;
        -moz-border-radius: 4px !important;
        border-radius: 4px !important;
        border: 1px solid #EEF2F7;;
        font-size: 16px;
        min-height: 36px;
      }
    }

    .boleto {
      margin: 20px 0;

       a {
         margin-left: 20px;
         font-size: 18px;
         font-weight: 500;
         color: #111;
         text-decoration: none;
         border-bottom: 1px solid #111;

         &:hover {
           font-weight: bold;
           text-decoration: none;
         }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/sales/newSale.vue